
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { Fragment } from 'react';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import HeroUnit from '#components/sections/hero-unit/HeroUnit';
import HeroButtonParade from '#components/hero-button-parade/HeroButtonParade';
import HeroTabs from '#components/common/heroTabs/HeroTabs';
import Recommendations from '#components/common/recommendations/Recommendations';
import SocialMeta from '#components/common/meta/SocialMeta';
import {
  GetNavigationDocument,
  GetSeriesEpisodePageDocument,
  useGetSeriesEpisodePageQuery,
} from '#types/generated/apollo-client';
import { getRoute } from '#utils';
import useTranslation from 'next-translate/useTranslation';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';

const EpisodeDetail = ({ seriesSlug, episodeSlug }) => {
  const { t } = useTranslation();
  const { data } = useGetSeriesEpisodePageQuery({
    variables: { seriesSlug, episodeSlug },
    initialFetchPolicy: 'cache-only',
    skip: !seriesSlug || !episodeSlug,
  });

  if (!data?.seriesEpisode) {
    return null;
  }

  const media = data?.seriesEpisode;
  const studioUrl = getRoute(media?.studio, t);

  return (
    <BasePageLayout>
      <Fragment>
        <SocialMeta
          about={{
            title: media.title,
            description: media.teaserDescription,
            image: media.backgroundImageFormats.sixteenByNine.large,
            type: 'video.episode',
          }}
        />

        <main className="page-main-container">
          <HeroUnit
            backgroundImageFormats={media?.backgroundImageFormats}
            categories={media?.categories}
            description={media?.shortDescription}
            fskRating={media?.fskRating}
            mediaQuality={media?.mediaQuality}
            mediaDuration={media?.mediaDuration}
            studioLogoImage={media?.studio?.logoImageFormats?.oneByOne?.small}
            studioName={media?.studio?.title}
            studioUrl={studioUrl}
            subtitle={media?.leadin}
            title={media?.title}
            titleImage={media?.logoImageFormats?.sixteenBySeven?.medium}
            year={media?.year}
            brandLogoImage={media?.logoImageFormats?.oneByOne?.medium}
            tags={media?.tags}
            buttonComponent={
              <HeroButtonParade mediaIri={media.iri} media={media} />
            }
          />
          <HeroTabs
            extras={media?.extras}
            mediaDescription={media.description}
            media={media}
            isEpisode={true}
          />
          <Recommendations items={media.recommendations} />
        </main>
      </Fragment>
    </BasePageLayout>
  );
};

 async function _getServerSideProps(context) {
  const client = initializeClient({
    context,
  });

  const seriesSlug = context.query.series;
  const episodeSlug = context.query.episode;

  //const series = client.
  //fetch page data
  const queries = await Promise.allSettled([
    client.query({
      query: GetSeriesEpisodePageDocument,
      variables: {
        seriesSlug,
        episodeSlug,
      },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Main' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Footer' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Profile' },
    }),
  ]);

  const pageResult = queries[0];

  if (
    pageResult.status !== 'fulfilled' ||
    !pageResult?.value?.data?.seriesEpisode
  ) {
    return {
      notFound: true,
    };
  }

  return addApolloState(client, { props: { seriesSlug, episodeSlug } });
}

export default EpisodeDetail;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/series/[series]/[episode]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  